/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /**
 * Bundle Discount
 */


// document.addEventListener('product:added', function(event) {
//   console.log("product:added");
//   window.RevyBundle.api.getTotal(response => {
//     console.log(response);
//     console.log(response.bundleTotal.discount);
//     //console.log(response.data.bundleTotal.discount);
//   })
//  });

/********************************************
 * Cart upsell - START
 ********************************************/

function showQuickview(productHandle, event) {
  event.preventDefault();
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  loadQuickviewProduct(productHandle);
}

function hideQuickview(){
  document.querySelector('#product-quickview').setAttribute('aria-hidden', 'true');
}

function loadQuickviewProduct(productHandle) {
  // productHandle = 'pillowcase-pair';
  const productWrapper = document.querySelector('#product-quickview .product-wrapper');

  // Fetch the product
  fetch(window.Shopify.routes.root + `products/${productHandle}?view=quickview`)
  .then(response => response.text().then( html => {
    
    // Load the quickview content into the productWrapper element
    productWrapper.innerHTML = html;

    let slideshowWrapper = '.quickview-gallery .Product__Slideshow';

    initCarousel(slideshowWrapper);

    let selectedColor = productWrapper.querySelector('.ColorSwatchQuickview__Radio:checked').value;
    let gallery = productWrapper.querySelectorAll('.Product__SlideItem');
    updateGallery(selectedColor, gallery, slideshowWrapper);

    const quickviewForm = productWrapper.querySelector('form');
    if( quickviewForm ){
      let selectedFixedOption = quickviewForm.querySelector('[data-option-position="1"]:checked').value;

      // Check option2 and option3 availability on first load
      if( quickviewForm.querySelector('[data-option-position="2"]')) {
        checkVariantAvailability(selectedFixedOption, quickviewForm);
      }
      // Listen to any input field changes
      quickviewForm.addEventListener('input', event => {

        // If color has been changed
        if( event.target.classList.contains('ColorSwatchQuickview__Radio') ){
          updateColorLabel(event.target);
          selectedColor = productWrapper.querySelector('.ColorSwatchQuickview__Radio:checked').value;
          updateGallery(selectedColor, gallery, slideshowWrapper);
        }

        if( quickviewForm.querySelector('[data-option-position="2"]')) {
          checkVariantAvailability(event.target.value, quickviewForm);
        }

        updateVariantId(quickviewForm);
      });
    }

    document.querySelector('#product-quickview').setAttribute('aria-hidden', 'false');
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }))
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateGallery(selectedColor, gallery, slideshowWrapper) {
  let flickityObj = Flickity.data(slideshowWrapper);

  // Remove all image slides
  flickityObj.remove(gallery);

  // Activate dot pagination - if not on already
  flickityObj.pageDots.activate();

  // Append only the selected color image slides
  for(let i=0; i<gallery.length; i++) {
    if( gallery[i].dataset.imgalt === selectedColor ){
      flickityObj.append(gallery[i]);
    }
  }

  // If slideshow length is 1, deactivate dot pagination
  if( flickityObj.slides.length <= 1 ){
    flickityObj.pageDots.deactivate();
  }
}

function checkVariantAvailability(selectedFixedOption, form) {
  form.querySelectorAll(`.Select--primary option[option1="${selectedFixedOption}"]`).forEach( opt => {
    let selectedOpt = form.querySelector(`[data-option-position="2"][value="${opt.getAttribute('option2')}"]`);
    if( opt.getAttribute('availability') == 'false' ){
      selectedOpt.classList.add('is-unavailable');
      selectedOpt.disabled = true;
    } else {
      selectedOpt.classList.remove('is-unavailable');
      selectedOpt.disabled = false;
    }
  });
}

function updateColorLabel(eventTarget) {
  // Update the color label
  if( eventTarget.classList.contains('ColorSwatchQuickview__Radio') ){
    eventTarget.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue').textContent = eventTarget.value;
  }
}

function updateVariantId(form) {
  let options = []
  for (let i=1; i<=3; i++) {
    let optEl = form.querySelector(`[data-option-position="${i}"]:checked`);
    if (optEl) {
      options.push(optEl.value);
    } else {
      options.push('');
    }
  }
  let selectedOption = form.querySelector(`.Select--primary option[option1="${options[0]}"][option2="${options[1]}"]`);
  selectedOption.selected = 'selected';

  // Update price
  let newPrice = selectedOption.dataset.price;
  form.closest('.quickview-info').querySelector('.ProductMeta__Price').textContent = newPrice;

  // Update submit button label and data
  let atcButton = form.querySelector('.ProductForm__AddToCart');
  atcButton.dataset.variantId = selectedOption.dataset.id;
  atcButton.querySelector('.money').textContent = newPrice;

  if( selectedOption.getAttribute('availability') == 'false' ){
    atcButton.disabled = true;
    atcButton.classList.remove('Button--primary');
    atcButton.classList.add('Button--secondary');
    atcButton.querySelector('.button_label').textContent = 'Sold Out';
    atcButton.querySelector('.Button__SeparatorDot').style.display = 'none'
    atcButton.querySelector('.money').style.display = 'none'
  } else {
    atcButton.disabled = false;
    atcButton.classList.remove('Button--secondary');
    atcButton.classList.add('Button--primary');
    atcButton.querySelector('.button_label').textContent = 'Add to Cart';
    atcButton.querySelector('.Button__SeparatorDot').style.display = 'unset'
    atcButton.querySelector('.money').style.display = 'unset'
  }
}

function quickAtc(event) {
  event.preventDefault();
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  let id = event.target.dataset.variantId;
  let qty = event.target.dataset.variantQty;

  let formData = {
    'items': [{
    'id': id,
    'quantity': qty
    }]
  };
   fetch(window.Shopify.routes.root + 'cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
      hideQuickview();
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
            variant: id,
            quantity: qty,
        },
      }));
      return response.json();
   })
   .catch((error) => {
     console.error('Error:', error);
   });
   
}
function initCarousel(wrapper) {
  if(!wrapper) {
    return;
  }
  let nodeList = document.querySelectorAll(`${wrapper}`);
  for (var i = 0, t = nodeList.length; i < t; i++) {
    var flkty = Flickity.data(nodeList[i]);
    if (!flkty) {
      // Check if element had flickity options specified in data attribute.
      var flktyData = nodeList[i].getAttribute('data-flickity');
      if (flktyData) {
          var flktyOptions = JSON.parse(flktyData);
          new Flickity(nodeList[i], flktyOptions);
      } else {
          new Flickity(nodeList[i]);
      }
    }
  }
}

document.addEventListener('drawer:open', function(event) {
  initCarousel('#sidebar-cart .SmallCarousel');
});

document.addEventListener('cart:change', function(event) {
  initCarousel('#sidebar-cart .SmallCarousel');
});

/********************************************
 * Cart upsell - END
 */

/** Update buttons in product page on variant change */
document.addEventListener('variant:changed', function(event) {
  const addToCartButton = document.querySelector('.ProductForm__AddToCart');
  const qtySelectorElem = document.querySelector('.ProductForm__QuantitySelector');
  const stickyAtcButton = document.querySelector('#sticky-atc .Button');
  const newPrice = Shopify.formatMoney(event.detail.variant.price, window.theme.moneyFormat);

  if( event.detail.variant.available ){
    qtySelectorElem.style.display = 'block';
    stickyAtcButton.classList.remove('Button--secondary');
    stickyAtcButton.classList.add('Button--primary');
    stickyAtcButton.textContent = 'Buy Now';
  } else {
    qtySelectorElem.style.display = 'none';
    stickyAtcButton.classList.remove('Button--primary');
    stickyAtcButton.classList.add('Button--secondary');
    stickyAtcButton.textContent = window.languages.productFormSoldOut;
  }

  let stickyAtcPrice = document.querySelectorAll('#sticky-atc .price-caption');
  for (const priceEl of stickyAtcPrice) {
    priceEl.innerHTML = newPrice;
  }
});

/**
 * Plugin to handle tabs
 */

(function ($) {

  'use strict';

  var pluginName = 'tabs',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   */
  function Plugin(element) {
    this.element = $(element);
    this.tabsNav = this.element.find('.tabs__nav li');
    this.tabsContent = this.element.find('.tabs__content');
    this.tabsNavLine = this.element.find('.tabs__nav-line');

    this.tabsNav.on('click', $.proxy(this.switchTab, this));

    var self = this;

    $(document).on('shopify:block:select', function(event) {
      $('html, body').animate({
        scrollTop: ($(event.target).offset().top - $('.header').height()) + 'px'
      }, 'fast');

      self.switchTab(event);
    });
  }

  Plugin.prototype.switchTab = function(event) {
    var currentTab = $(event.target),
      currentTabIndex = currentTab.attr('data-tab-index');
    currentTab.addClass('tabs__nav-item--active').siblings().removeClass('tabs__nav-item--active');
    this.tabsContent.find('.tabs__content-item').removeClass('tabs__content-item--active').eq(currentTabIndex).addClass('tabs__content-item--active');

    // Let's now move the magic line
    this.tabsNavLine.css({
      left: (currentTab.offset().left - this.tabsNav.first().offset().left),
      width: currentTab.width()
    });

    event.stopPropagation();
  };

  Plugin.prototype.destroy = function() {
    this.tabsNav.off('click');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

(function() {
  var plugin = $('.product-tabs').tabs();
  $(document).on('shopify:section:select, shopify:section:unload', function(event) {
    var tabs = $(event.target).find('.product-tabs');
    tabs.data('plugin_tabs').destroy();
  });

  $(document).on('shopify:section:load', function(event) {
    $(event.target).find('.product-tabs').tabs();
  });

})();

//OUT OF STOCK VARIANT LOGIC
function pickFirstVariant() {
  var firstVariantOption = productForm.querySelector(
    ".ProductForm__Option select option:not([disabled])"
  );

  if (firstVariantOption) {
    var newValue = firstVariantOption.value;
    var target = firstVariantOption.parentNode; // Select parent node which is select element
    console.log("NewValue", newValue);
    console.log("varianttarget", target);
  } else {
    console.log("No variant available");
    // Handle the case where no variant is available
  }
}

document.addEventListener("DOMContentLoaded", function() {
    var productForm = document.querySelector(".ProductForm"); // product form container
    var optionAvailability = [];

    var optionClasses = {}; // Initialize an empty object to store class values
    for (var i = 1; i <= 3; i++) {
        // Get the element with data-option-position equal to the current loop index
        var elementWithPosition = document.querySelector('[data-option-position="' + i + '"]');

        // Check if the element exists
        if (elementWithPosition) {
            // Get the class of the element and extract the first class name
            var classNames = elementWithPosition.getAttribute("class").split(" ");
            optionClasses['option' + i + 'class'] = classNames[0]; // Take the first class name
        } else {
            // If no element is found, store an empty string in the optionClasses object
            optionClasses['option' + i + 'class'] = "";
        }
    }
    //console.log("OPTION CLASS", optionClasses);
    //var option1SwatchOptions = document.querySelector(".ColorSwatch__Radio");

    if (optionClasses.option1class) {
        var option1SwatchOptions = document.querySelector(`.${optionClasses.option1class}`);
    }
    if (optionClasses.option2class) {
        var option2SwatchOptions = document.querySelector(`.${optionClasses.option2class}`);
    }
    if (optionClasses.option3class) {
        var option3SwatchOptions = document.querySelector(`.${optionClasses.option3class}`);
    }

    if (productForm) {
        var variantOptions = productForm.querySelectorAll(
            ".ProductForm__Option select"
        );

        variantOptions.forEach(function(option) {
            option
                .querySelectorAll("option:not([disabled])")
                .forEach(function(variant) {
                    var variantId = variant.value;
                    var variantAvailability = variant.getAttribute("availability");
                    var optionName1 = variant.getAttribute("option1");
                    var optionName2 = variant.getAttribute("option2");
                    var optionName3 = variant.getAttribute("option3");

                    var variantInfo = {
                        variantId: variantId,
                        option1: optionName1,
                        option2: optionName2,
                        option3: optionName3,
                        availability: variantAvailability,
                    };

                    optionAvailability.push(variantInfo);
                });
        });

        //console.log("Option Availability:", optionAvailability);
    } else {
        console.log("Product form not found");
    }

    function areVariantsAvailableForOption1(optionAvailability, optionValue) {
        return optionAvailability.some(
            (variant) => variant.option1 === optionValue.getAttribute("value")
        );
    }

    function areVariantsAvailableForOption2(selectedVariants, option2Value) {
       // console.log('COLOR areVariantsAvailableForOption2', !option1SwatchOptions);
        return selectedVariants.some(
          (variant) => variant.option2 === option2Value.getAttribute("value")
      );
    }
    function areVariantsAvailableForOption3(selectedVariants, option3Value) {

      var checkedInputOption1 = document.querySelector('input[type="radio"][name="option-0"]:checked');
      var checkedInputOption2 = document.querySelector('input[type="radio"][name="option-1"]:checked');

      filteredVariantsOption3 = selectedVariants.filter(variant =>
        variant.option1 === checkedInputOption1.getAttribute("value") &&
        variant.option2 === checkedInputOption2.getAttribute("value")
    );
    //console.log('3333 vari', filteredVariantsOption3);
      return filteredVariantsOption3.some(
        (variant) => variant.option3 === option3Value.getAttribute("value")
    );
  }

    function updateInputsOption1(optionAvailability) {
        //console.log("selectedVar updateInputsOption2", optionAvailability);

        // Get all swatch options
        var option1SwatchOptionsAll = document.querySelectorAll(`.${optionClasses.option1class}`);
        option1SwatchOptionsAll.forEach(function(option) {
            // Check if there are any available variants for this color
            var variantsAvailable = areVariantsAvailableForOption1(
                optionAvailability,
                option
            );

            // Add or remove the 'is-unavailable' class based on variant availability
            if (!variantsAvailable) {
                option.classList.add("is-unavailable");
            } else {
                option.classList.remove("is-unavailable");
            }
        });
    }
 

    function updateInputsOption2(selectedVariants) {
       // console.log("selectedVar updateInputsOption2", selectedVariants);

        // Get all size swatch options
        var option2SwatchOptionsAll = document.querySelectorAll(`.${optionClasses.option2class}`);
        option2SwatchOptionsAll.forEach(function(option) {
            // Check if there are any available variants for this option1/size
            var variantsAvailable = areVariantsAvailableForOption2(
                selectedVariants,
                option
            );

            // Add or remove the 'is-unavailable' class based on variant availability
            if (!variantsAvailable) {
                option.classList.add("is-unavailable");
            } else {
                option.classList.remove("is-unavailable");
            }
        });
    }
    function updateInputsOption3(selectedVariants) {
      //console.log("selectedVar updateInputsOption3", selectedVariants);

      // Get all size swatch options
      var option3SwatchOptionsAll = document.querySelectorAll(`.${optionClasses.option3class}`);
      option3SwatchOptionsAll.forEach(function(option) {
          // Check if there are any available variants for this option1/size
          var variantsAvailable = areVariantsAvailableForOption3(
              selectedVariants,
              option
          );

          // Add or remove the 'is-unavailable' class based on variant availability
          if (!variantsAvailable) {
              option.classList.add("is-unavailable");
          } else {
              option.classList.remove("is-unavailable");
          }
      });
  }
  if(option1SwatchOptions){updateInputsOption1(optionAvailability);}
    if(option2SwatchOptions){updateInputsOption2(optionAvailability);}
    if(option3SwatchOptions){updateInputsOption3(optionAvailability);}

    function handleOption1Change(option1Value) {
        // Get selected options
        //console.log("handleOPTION2Change", option1Value)
        const matchingVariantsOpt1 = optionAvailability.filter(
            (variant) => variant.option1 === option1Value
        );
        // Update inputs based on variant availability
        if(option2SwatchOptions){
          updateInputsOption2(matchingVariantsOpt1);
          if(option3SwatchOptions){
            updateInputsOption3(matchingVariantsOpt1);
          }
        }
      
    }

    function handleOption2Change(sizeOptionValue) {
        //console.log("handleOPTION2Change", sizeOptionValue)
            // Get selected options
        const matchingVariants = optionAvailability.filter(
            (variant) => variant.option2 === sizeOptionValue
        );
        // Update input3 based on variant availability
        if(option3SwatchOptions){updateInputsOption3(matchingVariants);}
    }


    var checkedInputOption1 = document.querySelector('input[type="radio"][name="option-0"]:checked');

    //If there is Color variant checked then will update size option style, suppose to run only once
    if (checkedInputOption1 && option1SwatchOptions) {
        handleOption1Change(checkedInputOption1.getAttribute('value'));
    }

    const optionInputs = document.querySelectorAll(
        'input[type="radio"][name^="option"]'
    );
    optionInputs.forEach((input) => {
        input.addEventListener("change", () => {
            //if option-0 == color
            if (input.name == "option-0" && option1SwatchOptions) {
                handleOption1Change(input.value);
            }
            if (input.name == "option-1" && option2SwatchOptions) {
               handleOption2Change(input.value);
            }
            renderLabelTag()
        });
    });

//grouping sibling color based on their color group
  function groupItems() {
    var productContainer = document.getElementById("productChildVariant");

    if(productContainer ){
      var colorOptionWrappers = productContainer.querySelectorAll(".color-option-wrapper");
      var productGroups = {};
  
      colorOptionWrappers.forEach(function(wrapper) {
        var label = wrapper.querySelector(".ProductForm__Label").textContent.trim();

        if (!productGroups[label]) {
          productGroups[label] = document.createElement("div");
          productGroups[label].classList.add("color-option-wrapper");
          productGroups[label].innerHTML = '<span class="ProductForm__Label">' + label + '</span><ul class="HorizontalList HorizontalList--spacingTight"></ul>';
          
        }
  
        var ul = productGroups[label].querySelector("ul");
        var items = wrapper.querySelectorAll(".HorizontalList__Item");
        items.forEach(function(item) {
          ul.appendChild(item);
        });
      });
  
      productContainer.innerHTML = "";
      for (var label in productGroups) {
        productContainer.appendChild(productGroups[label]);
      }
    }
   
  }
  groupItems();

   // for SIBLING PDP: function for grouping color items under same label
   function groupSiblingItems() {
    var productContainer = document.getElementById("productSiblingVariants");
    if (productContainer){
      var colorOptionWrappers = productContainer.querySelectorAll(".color-option-wrapper");
      var productGroups = {};

    colorOptionWrappers.forEach(function(wrapper) {
        var labelElement = wrapper.querySelector(".ProductForm__Label");
        var label = labelElement.textContent.trim();
        var labelId = labelElement.id;
        console.log("label", label)
        if (!productGroups[label]) {
            productGroups[label] = document.createElement("div");
            productGroups[label].classList.add("color-option-wrapper");
            var labelHTML = '<span class="ProductForm__Label"';
            // Check if there is an id for the label, if yes, add it to the HTML
            if (labelId) {
                labelHTML += ' id="' + labelId + '"';
            }
            labelHTML += '>';
            
            // Check if the label has id="labelCurrentSibling"
            if (labelId === "labelCurrentSibling") {
                var labelText = labelElement.textContent.split(":")[0].trim(); // Extract the text before ":"
                labelHTML += labelText + ':';
        
            } else {
                labelHTML += label;
            }
            
            labelHTML += '</span><ul class="HorizontalList HorizontalList--spacingTight"></ul>';
            productGroups[label].innerHTML = labelHTML;
            console.log(productGroups[label])
        }
        if (productGroups[label] && labelId === "labelCurrentSibling") {
          productGroups[label].querySelector(".ProductForm__Label").id = "labelCurrentSibling";
        }


        var ul = productGroups[label].querySelector("ul");
        var items = wrapper.querySelectorAll("li.HorizontalList__Item");
        items.forEach(function(item) {
            ul.appendChild(item);
        });
    });

    //delete old wrapper and add the new one
    productContainer.innerHTML = "";
    for (var label in productGroups) {
        productContainer.appendChild(productGroups[label]);
    }
    }
    
}
groupSiblingItems();

function showSelectedColor() {
  // Get the label with id="labelCurrentSibling"
  var labelCurrentSibling = document.getElementById("labelCurrentSibling");

  // Check if the label exists and has the id="labelCurrentSibling"
  if (labelCurrentSibling) {
      // Create a span element for showing color value
      var colorValueSpan = document.createElement("span");
      colorValueSpan.id = "color-value-label";
      labelCurrentSibling.insertAdjacentElement('afterend', colorValueSpan);

      // Function to update the color value span
      function updateColorValue() {
          // Get the checked input within the parent element of the label
          var checkedInput = labelCurrentSibling.parentElement.querySelector("input[type='radio']:checked");

          // If a checked input exists, update the color value span
          if (checkedInput) {
              var colorValue = checkedInput.getAttribute("data-variant-value");
              colorValueSpan.textContent = " "+ colorValue;
          }
      }

      // Call the function to update color value when the page is loaded
      updateColorValue();

      // Get all radio inputs within the parent element of the label
      var radioInputs = labelCurrentSibling.parentElement.querySelectorAll("input[type='radio']");

      // Add event listener to each radio input to update color value span
      radioInputs.forEach(function(input) {
          input.addEventListener("change", updateColorValue);
      });
  }
}

// Call the function to show selected color
showSelectedColor();

});

const renderLabelTag = () => {
    const label = document.querySelector('.tag-wrapper')
    let queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    let varId = urlParams.get('variant')
    if (metafieldVariants) {
        for (const meta of metafieldVariants) {
            if (meta.id == varId) {
                if (meta.label != undefined) {
                    label.innerHTML = `<span class=labelTag>${meta.label}</span>`
                } else {
                    label.innerHTML = ''
                }
            }
        }
    }
}

async function handleBundleCartRemoval(target, bundleItems) {
    bundleItems.forEach(async (item, index) => {
        if (target.getAttribute('data-variant-id') != item.getAttribute('data-variant-id')) {
            elementToAnimate = null
            let fetchItem = await fetch(window.routes.cartChangeUrl + '.js', {
                body: JSON.stringify({
                    id: item.getAttribute('data-line-id'),
                    properties: {},
                }),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
                },
            }).catch(function (err) {
                console.log(`Error: ${err}`)
            })
        }
    })
}